import React from "react";
// import Banner from '../../components/UserSideComponents/housingrule/Banner'
import Rule from "../../components/UserSideComponents/housingrule/Rule";
import Building from "../../components/UserSideComponents/housingrule/Building";
import Betting from "../../components/UserSideComponents/housingrule/Betting";
import Banner from "../../components/UserSideComponents/abouts/Banner";

function HousingRule() {
  return (
    <div>
      <Banner title="Housing Rule" />
      <Rule />
      <Building />
      <Betting />
    </div>
  );
}

export default HousingRule;
